import { h } from "@stencil/core";
// interface FormComponent {
//   error: boolean;
//   hideValidationMessage: boolean;
//   validationMessage: string | undefined;
// }
function requiredLabel(component) {
    if (component.required) {
        return h("span", { class: "required" }, "*");
    }
}
function formMessage(children) {
    /* The following snipet of jsx is intended to be inserted at the end of every form-x component.
    The purpose of this jsx snippet is to show error or warning messages,
    inserted on the "message" slot with a gxg-form-message component
    */
    return (h("div", { class: "messages-wrapper", role: "alert", "aria-live": "assertive" }, children));
}
function formHandleValidation(component, formElement) {
    const hasError = !formElement.validity.valid;
    if (hasError) {
        component.validationMessage =
            component.validationMessage || formElement.validationMessage;
        return true;
    }
    else {
        return false;
    }
}
function formMessageLogic(comp) {
    {
        return comp.informationMessage ||
            (!comp.disabled &&
                comp.validationMessage &&
                (comp.validationStatus === "error" ||
                    comp.validationStatus === "warning" ||
                    comp.validationStatus === "success"))
            ? formMessage([
                comp.informationMessage ? (h("gxg-form-message", { type: "indeterminate" }, comp.informationMessage)) : null,
                comp.validationStatus === "error" ||
                    comp.validationStatus === "warning" ||
                    comp.validationStatus === "success" ? (h("gxg-form-message", { type: comp.validationStatus }, comp.validationMessage)) : null,
            ])
            : null;
    }
}
export function formTooltipLogic(comp, hideTooltip) {
    {
        const show = comp.validationStatus !== "indeterminate" &&
            comp.validationMessage.length > 0;
        const color = comp.validationStatus;
        return (
        // <div class="tooltip-outer-wrapper">
        h("div", { class: {
                "tooltip-inner-wrapper": true,
                "tooltip-inner-wrapper--visible": show,
                "tooltip--hidden": hideTooltip,
            } }, h("gxg-tooltip", { label: comp.validationMessage, noBorder: true, alignEnd: true, flex: true, fixed: true }, h("gxg-icon", { color: color, type: `gemini-tools/${comp.validationStatus}` })))
        // </div>
        );
    }
}
export { requiredLabel, formHandleValidation, formMessage, formMessageLogic, };
//# sourceMappingURL=form.js.map
